import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '../ui/Styles';
import imgPortrait from '../../images/potrait.png';
import { Container, Title } from './Styles';

const About = ({ viewable }) => {
  return (
    <Container className="about-page" viewable={viewable}>
      <Title>About</Title>
      <Row className="about-page-row">
        <Column className="about-page-col" w={[1, 1 / 3]}>
          <img alt="portrait" src={imgPortrait} />
        </Column>
        <Column className="about-page-col" w={[1, 2 / 3]}>
          <h3>
            My Name is Tobias Ighofose, I'm an Interactive Developer. Aside from that, I'm a Football mad, music loving,
            movie addict. I fell in love with programming over 16 years ago, ever since then, I've been breathing and
            living coding. Get in touch, if you've got something cool you need to get done.
          </h3>
        </Column>
      </Row>
    </Container>
  );
};

About.propTypes = {
  viewable: PropTypes.bool.isRequired
};

export default About;



// WEBPACK FOOTER //
// ./src/components/AboutPage/index.js